import React, { ReactElement, useEffect } from 'react';

// This component was created as a workaround to address accessibility bugs in antd components
// which are used extensively in this project. As many of those have no support for accessibility
// this component works by providing by dynamically rendering a component provided as a prop,
// and using DOM apis to add/update its attributes, onde rendered.
// Note this was custom built based on the rendered DOM for the existing version of antd, do 
// not use this component in genral to modify non-ant components, as it won't work.
const AccessibleAntdComponent = (props: any): any => {
    useEffect(()=> {
      const elementId = props?.id;
      if(!elementId) {
        return;
      }
  
      const rootElement = document.getElementById(elementId);
      props?.parentRole &&  rootElement?.setAttribute('role', props.parentRole);

      const domChildrenElement = props?.applyToChildrenOnly 
        ? rootElement?.children
        : [rootElement];
      
      if(!domChildrenElement){
        return;
      }
  
      Array.from(domChildrenElement).forEach(domElement => {
        props?.role && domElement?.setAttribute('role', props.role);
        props['aria-label'] && domElement?.setAttribute('aria-label', props['aria-label']);
        props['aria-busy'] && domElement?.setAttribute('aria-busy', props['aria-busy']);
      });
    }, [props?.isVisible])
  
    let Component = props?.component;
    if(!Component) {
      console.error('Component prop must be provided!')
      return <React.Fragment />;
    }

    return <Component {...props} />
  }


  export const AccessibleTab = (props: any) => AccessibleAntdComponent({
    applyToChildrenOnly: true,
    ...props
  });

  export default AccessibleAntdComponent;